import { DEFAULT_PAGE_SIZE } from './constants';

export const trimByPage = (pageIndex, data) => {
  const trimStart = pageIndex * DEFAULT_PAGE_SIZE;
  const trimEnd = trimStart + DEFAULT_PAGE_SIZE;
  return data.slice(trimStart, trimEnd);
};
